
import { alpha, styled } from "@mui/material/styles";
import Popover from '@mui/material/Popover';
import { InputLabel, Select, MenuItem, FormControl, Button, CircularProgress, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import React, { useState } from "react";
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import config from '../../hoa-config';
import dashboardServices from "../../services/hoa-dashboard-api-service";
import datastore from "../../store/hoa-datastore";
import dayjs from 'dayjs';
import CustomDateField from "../../Container/custom-date-field";
import { TextFieldComponent, OrgDropDown, RadioGroupComponent } from './shared-filter-components';

const InputTextFeild = styled(TextField)(({ theme, error }) => ({
    "& .MuiFilledInput-root": {
        border: !error ? "1px solid #e2e2e1" : "1px solid #FF0000",
        overflow: "hidden",
        borderRadius: 4,
        backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
        transition: theme.transitions.create([
            "border-color",
            "background-color",
            "box-shadow"
        ]),
        "&:hover": {
            backgroundColor: "transparent"
        },
        "&.Mui-focused": {
            backgroundColor: "transparent",
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: '#0000ff'
        },
    }
}));


export default function ApplyAdvanceFilterComponent(props: any) {

    const { anchorEl, setAnchorEl, onChangeText, onMoreFilterClick, options, tagType } = props;

    return (
        <Popover
            open={anchorEl ? true : false}
            anchorEl={anchorEl}
            onClose={() => onMoreFilterClick('Cancel')}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            PaperProps={{
                elevation: 0,
                style: {
                    marginTop:'10px',
                    width: '589px',
                    maxHeight: '520px',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    background: '#FFFFFF',
                    border: '1px solid #E8E8E8',
                    boxShadow: '0px 10px 26px rgba(0, 0, 0, 0.2)',
                    borderRadius: '8px'
                }
            }}
        >
            <main style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                {(tagType === 'Hoa' || tagType === 'Municipality' || tagType === 'Property' || tagType === 'Mail' || tagType === 'Email' || tagType === 'Document') && (
                <div  style={{ width: 'calc(100% - 48px)', borderBottom: '1px solid  #F7F7F7', marginTop: '24px' }}>
                    <div style={tagType != 'Property' ? { justifyContent: 'flex-start'} : {}}>
                        <div className={(datastore.userRole !== config.userRoles.OrganizationUser || tagType === 'Property' ) && (tagType != 'Mail' && tagType != 'Email' && tagType != 'Municipality' && tagType != 'Document')  ? 'advance-filter-container' : 'advance-filter-container-single'}>
                        <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all'  }}>{`${tagType === 'Hoa' ? 'HOA' : tagType} ID`}</span>
                        <InputTextFeild
                            style={tagType != 'Property' ? { width: '184px', margin: '2px', marginLeft: '40px'} : { width: '184px', margin: '2px'}}
                            label={`${tagType === 'Hoa' ? 'HOA' : tagType} ID`}
                            InputProps={{ disableUnderline: true }}
                            variant="filled"
                            value={options.entityId || ''}
                            name='entityId'
                            onChange={onChangeText}
                        />
                        {/* Organization filter */}
                        {(tagType === 'Document') &&  (
                        <FormControl>
                            <Autocomplete
                                ListboxProps={{ style: { maxHeight: "200px" } }}
                                style={{ width: "184px", margin: "2px", marginLeft: '38px' }}
                                disableClearable
                                disablePortal
                                value={
                                    config.hoaOrganizations.find(
                                        (org: any) => org.id === options.organizationId
                                    ) || null
                                }
                                options={config.hoaOrganizations}
                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                onChange={(e, v) => {
                                    if (v !== null) {
                                        onChangeText({ target: { name: "organizationId", value: v.id } });
                                    }
                                }}
                                renderInput={(params: any) => (
                                    <TextField {...params} label="Organization Name" name="organizationId" />
                                )}
                            />
                        </FormControl>
                        )}
                        {(tagType === 'Hoa' && datastore.userRole !== config.userRoles.OrganizationUser) &&  (
                            <FormControl>
                                <Autocomplete
                                    ListboxProps={{ style: { maxHeight: "200px" } }}                                
                                    style={{ width: "184px", margin: '2px', marginLeft: '38px' }}
                                    disableClearable
                                    disablePortal
                                    value={config.hoaOrganizations.find((org: any) => org.id === options.hoaClientInfo) || null}
                                    options={config.hoaOrganizations}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={(e, v) => {
                                    if (v !== null) {
                                        onChangeText({ target: { name: 'hoaClientInfo', value: v.id } });
                                    }
                                    }}
                                    renderInput={(params) => (
                                    <TextField 
                                    {...params} 
                                    label="Organization Name" 
                                    name="hoaClientInfo" 
                                />
                                )}
                                />
                            </FormControl>  
                        )}
                        {
                            tagType === 'Property' && (
                            <FormControl>
                                <Autocomplete
                                    ListboxProps={{ style: { maxHeight: "100px" } }}
                                    style={{ width: "184px", margin: '2px' }}
                                    disableClearable
                                    disablePortal
                                    defaultValue={'All'}
                                    value={options.linkStatus || ''}
                                    options={config.propertyLinkStatus}
                                    onChange={(e, v) => {
                                        if (v !== null) {
                                            onChangeText({ select: { key: 'linkStatus', value: v } })
                                        }
                                    }}
                                    renderInput={(params: any) => <TextField name='linkStatus' {...params} label="Tag" />}
                                />
                            </FormControl>
                            )
                        }
                        </div>
                    </div>
                </div>
                )}
                {(tagType === 'Property') && ExternalIdFilterComp('External ID',onChangeText, options)}
                {(tagType === 'Mail') && FilterComp('Folder Name',onChangeText, options.folderName, "folderName")}
                {(tagType === 'Mail') && OrganizationDropDown('Organization', onChangeText, options)}
                {(tagType === 'Municipality' || tagType === 'Hoa' || tagType === 'Property') && LocationFilterComp('Location',onChangeText, options ,tagType)}
                {(tagType === 'Property') && HoaDetailsNdOrganization('HOA Details',onChangeText, options)}
                {(tagType === 'Hoa') && PropertiesNoFilterComp('Number Of Properties',onChangeText, options)}
                {(tagType === 'Document') && DocumentTypeNdStatus('Document Details', 'HOA Details',onChangeText, options)}
                {(tagType === 'Municipality' || tagType === 'Hoa' || tagType === 'Property' || tagType === 'Document' || tagType === 'Mail' || tagType === 'Email') && LastUpdatedFilterComp('Last Updated Date',onChangeText, options)}
                {(tagType === 'Mail' || tagType === 'Email') && MailEmailAssignedResponsible('Assigned Responsible',onChangeText, options)}
                {(tagType === 'Mail' || tagType === 'Email') && ReceivedTimeFilterComp('Actual Receive Date',onChangeText, options, tagType)}
                {(tagType === 'Mail' || tagType === 'Email') && PlatformUpdateDateFilterComp('Platform Upload Date',onChangeText, options)}
                {(tagType === 'Mail') && FilterComp('SPS Document Type',onChangeText, options.spsDocumentType, "spsDocumentType")}
                {(tagType === 'Property') && PropertyAddedBy('Added By',onChangeText, options)}
                {(tagType === 'Hoa') && HoaType('Type', onChangeText, options)}
                {
                    tagType === "PropertyTask" &&
                    <>
                        <TextFieldComponent title={'External ID'} onChangeText={onChangeText} options={options} value={'externalId'} />
                        <TextFieldComponent title={'Property ID'} onChangeText={onChangeText} options={options} value={'propertyId'} />
                        <OrgDropDown title={'Organization'} onChangeText={onChangeText} options={options} />
                        <RadioGroupComponent title={'Type'} onChangeText={onChangeText} options={options} value={'taskSourceType'} />
                    </>
                }
                <div className="filter-footer">
                    <Button onClick={()=>onMoreFilterClick('Clear')} startIcon={<DeleteOutlineSharpIcon style={{ color: '#3576E5' }} />} id='clear-all-btn'><span id='btn-title'>Clear All</span></Button>
                    <div>
                        <Button onClick={()=>onMoreFilterClick('Cancel')} id='cancel-btn'><span id='btn-title'>Cancel</span></Button>
                        <Button onClick={()=>onMoreFilterClick('Apply')} variant="contained" id='apply-btn'><span style={{ color: 'white' }} id='btn-title'>Apply Filter</span></Button>
                    </div>
                </div>
            </main>
        </Popover>
    )
}

const OrganizationDropDown = (title:string,onChangeText:any, options:any) => {

    return (
		<div
			key={title}
			style={{
				width: "calc(100% - 48px)",
				borderBottom: "1px solid  #F7F7F7",
				padding: "24px 0px",
                display:'flex',
                alignItems:'center',
                gap:'32px'
			}}
		>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
			<FormControl>
				<Autocomplete
					ListboxProps={{ style: { maxHeight: "200px" } }}
					style={{ width: "184px", margin: "2px" }}
					disableClearable
					disablePortal
					value={
						config.hoaOrganizations.find(
							(org: any) => org.id === options.organizationId
						) || null
					}
					options={config.hoaOrganizations}
					getOptionLabel={(option) => option.name}
					isOptionEqualToValue={(option, value) => option.id === value.id}
					onChange={(e, v) => {
						if (v !== null) {
							onChangeText({ target: { name: "organizationId", value: v.id } });
						}
					}}
					renderInput={(params: any) => (
						<TextField {...params} label="Organization Name" name="organizationId" />
					)}
				/>
			</FormControl>
		</div>
	);

}

const HoaDetailsNdOrganization = (title:string,onChangeText:any, options:any) => {

    return(
        <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: '1px solid  #F7F7F7', marginTop: '24px' }}>
            <div className='advance-filter-container' style={datastore.userRole == config.userRoles.OrganizationUser ? {justifyContent: 'start'} : {}}>
                <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
                <InputTextFeild
                    style={datastore.userRole == config.userRoles.OrganizationUser ? { width: '184px', margin: '2px', marginLeft: '40px'} : { width: '184px', margin: '2px' }}
                    label='HOA ID'
                    InputProps={{ disableUnderline: true }}
                    variant="filled"
                    value={options.hoaId || ''}
                    name='hoaId'
                    onChange={onChangeText}
                />
                {
                datastore.userRole !== config.userRoles.OrganizationUser ? (
                    <FormControl>
                    <Autocomplete
                      ListboxProps={{ style: { maxHeight: "200px" } }}  
                      style={{ width: "184px", margin: '2px' }}
                      disableClearable
                      disablePortal
                      value={config.hoaOrganizations.find((org: any) => org.id === options.organizationId) || null}
                      options={config.hoaOrganizations}
                      getOptionLabel={(option) => option.name}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      onChange={(e, v) => {
                        if (v !== null) {
                          onChangeText({ target: { name: 'organizationId', value: v.id } });
                        }
                      }}
                      renderInput={(params: any) => (
                        <TextField 
                          {...params} 
                          label="Organization Name" 
                          name="organizationId" 
                        />
                      )}
                    />
                  </FormControl>
                  
                 ) : <></>
                }

            </div>
        </div>
    )
}

const DocumentTypeNdStatus = (title:string, titleTwo: string, onChangeText:any, options:any) => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [documentTypes, setDocumentTypes] = useState<any>([]);

    const onEnter = async (event: any) => {
        if (event.key === "Enter") {
          setLoading(true);
          const docTypes = await dashboardServices.getHoaDocumentType(event.target.value);
          if(docTypes){
            setDocumentTypes(docTypes.data);
            setLoading(false);
          }
        }
    }

    return(
        <>
        <div  style={{ width: 'calc(100% - 48px)', borderBottom: '1px solid  #F7F7F7', marginTop: '24px' }}>
            <div className='advance-filter-container'>
                <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-word' }}>{`Document Details`}</span>
                <Autocomplete
                    id="asynchronous-demo"
                    sx={{ width: '184px',  margin: '2px' }}
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    onKeyDown={onEnter}
                    onChange={(option:any, value:any) => onChangeText({select:{key:'documentType', value:value}})}
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option: any) => option}
                    value={options.documentType || null}
                    options={documentTypes}
                    loading={loading}
                    renderInput={(params: any) => (
                        <TextField
                        {...params}
                        label={`Document Type`}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                            ),
                        }}
                        />
                    )}
                />
                <FormControl style={{ width: '184px', margin: '2px' }}>
                    <InputLabel id="added-by-label">Added By</InputLabel>
                    <Select
                        labelId="added-by-label"
                        value={options.addedBy || ''}
                        onChange={onChangeText}
                        name="addedBy"
                        disableUnderline
                        label="Added By"
                    >
                    {config.documentAddedByOptions.map((option: any) => (
                        <MenuItem key={option.id} value={option.name}>
                            {option.name}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl>


            </div>
        </div>
        <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: '1px solid  #F7F7F7', marginTop: '24px' }}>
            <div className='advance-filter-container'>
                <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{titleTwo}</span>
                <InputTextFeild
                    style={{ width: '184px', margin: '2px' }}
                    label='HOA Vendor ID'
                    InputProps={{ disableUnderline: true }}
                    variant="filled"
                    value={options.hoaVendorID || ''}
                    name='hoaVendorID'
                    onChange={onChangeText}
                />
                <InputTextFeild
                    style={{ width: '184px', margin: '2px' }}
                    label='External ID'
                    InputProps={{ disableUnderline: true }}
                    variant="filled"
                    value={options.externalID || ''}
                    name='externalID'
                    onChange={onChangeText}
                />
            </div>
        </div>
        </>
    )
}

const DetailsFilterComp = (title: string,onChangeText:any, options:any) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: title !== 'Last Updated Date' ? '1px solid  #F7F7F7' : 'none', marginTop: '24px' }}>
        <div className='advance-filter-container'>
            <span style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
            <FormControl>
                <InputLabel variant='filled'>Market</InputLabel>
                <Select
                    style={{ width: "184px", margin: '2px' }}
                    variant='filled'
                    defaultValue={'all'}
                    label="Market"
                >
                    <MenuItem value={'all'}>All</MenuItem>
                    <MenuItem value={'x'}>x</MenuItem>
                </Select>
            </FormControl>
            <InputTextFeild
                style={{ width: '184px', margin: '2px' }}
                label='Hoa Name'
                InputProps={{ disableUnderline: true }}
                variant="filled"
                value={options.hoaName || ''} 
                name='hoaName'
                onChange={onChangeText}
            />
        </div>
    </div>
)

const LocationFilterComp = (title: string, onChangeText:any, options:any, tagType:string) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: title !== 'Last Updated Date' ? '1px solid  #F7F7F7' : 'none', marginTop: '24px' }}>
        <div className='advance-filter-container'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
            {
                (tagType === 'Hoa' || tagType === 'Property' ) &&
                <InputTextFeild
                    style={{ width: '184px', margin: '2px' }}
                    label='City'
                    InputProps={{ disableUnderline: true }}
                    variant="filled"
                    value={options.city || ''}
                    name='city'
                    onChange={onChangeText}
                />
            }
            {
                tagType === 'Municipality' &&
                <FormControl>
                    <Autocomplete
                        ListboxProps={{ style: { maxHeight: "100px" } }}
                        style={{ width: "184px", margin: '2px' }}
                        disableClearable
                        disablePortal
                        defaultValue={'All'}
                        value={options.state || ''}
                        options={config.stateOptions}
                        onChange={(e, v) => {
                            if (v !== null) {
                                onChangeText({ select: { key: 'state', value: v } })
                            }
                        }}
                        renderInput={(params: any) => <TextField name='state' {...params} label="State" />}
                    />
                </FormControl>
            }
            <FormControl>
                <Autocomplete
                    ListboxProps={{ style: { maxHeight: "100px"} }}
                    style={{ width: "184px", margin: '2px' }}
                    disableClearable
                    disablePortal
                    defaultValue={'All'}
                    value={options.market || ''} 
                    options={config.marketOptions}
                    onChange={(e, v) => {
                        if(v !== null) {
                            onChangeText({select:{key:'market', value:v}})
                        }
                    }}
                    renderInput={(params: any) => <TextField name='market' {...params} label="Market" />}
                />
            </FormControl>
        </div>
    </div>
)

const ExternalIdFilterComp = (title: string, onChangeText:any, options:any) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: title !== 'Last Updated Date' ? '1px solid  #F7F7F7' : 'none', marginTop: '24px' }}>
        <div className='advance-filter-container-single'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
                <InputTextFeild
                    style={{ width: '184px', margin: '2px', marginLeft:"38px" }}
                    label='External ID'
                    InputProps={{ disableUnderline: true }}
                    variant="filled"
                    value={options.externalId || ''}
                    name='externalId'
                    onChange={onChangeText}
                />
        </div>
    </div>
)


const FilterComp = (title: string, onChangeText:any, value:any, name:string) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: title !== 'Last Updated Date' ? '1px solid  #F7F7F7' : 'none', marginTop: '24px' }}>
        <div className='advance-filter-container-single'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-word' }}>{title}</span>
                <InputTextFeild
                    style={{ width: '184px', margin: '2px', marginLeft:"38px" }}
                    label={title}
                    InputProps={{ disableUnderline: true }}
                    variant="filled"
                    value={value || ''}
                    name={name}
                    onChange={onChangeText}
                />
        </div>
    </div>
)

const PropertiesNoFilterComp = (title: string, onChangeText:any, options:any) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: title !== 'Last Updated Date' ? '1px solid  #F7F7F7' : 'none', marginTop: '24px' }}>
        <div className='advance-filter-container'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-word' }}>{title}</span>
            <InputTextFeild
                style={{ width: '184px', margin: '2px' }}
                label='Maximum'
                InputProps={{ disableUnderline: true }}
                variant="filled"
                type={'number'}
                value={options.maximum || ''} 
                name='maximum'
                onChange={onChangeText}
            />
            <InputTextFeild
                name='minimum'
                style={{ width: '184px', margin: '2px' }}
                label='Minimum'
                InputProps={{ disableUnderline: true }}
                variant="filled"
                type={'number'}
                value={options.minimum || ''} 
                onChange={onChangeText}
            />
        </div>
    </div>
)

const LastUpdatedFilterComp = (title: string,onChangeText:any, options:any) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', marginTop: '24px' }}>
        <div className='advance-filter-container'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
            <CustomDateField 
                label='From'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.from || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'from', value:value}})}
            />
            <CustomDateField 
                label='To'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.to || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'to', value:value}})}
            />
        </div>
    </div>
)

const MailEmailAssignedResponsible = (title: string, onChangeText:any, options:any) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: title !== 'Last Updated Date' ? '1px solid  #F7F7F7' : 'none', marginTop: '24px' }}>
        <div className='advance-filter-container'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-word' }}>{title}</span>
            <InputTextFeild
                style={{ width: '410px', margin: '2px' }}
                label='Email'
                InputProps={{ disableUnderline: true }}
                variant="filled"
                value={options.lastUpdatedBy || ''} 
                name='lastUpdatedBy'
                onChange={onChangeText}
            />
        </div>
    </div>
)

const ReceivedTimeFilterComp = (title: string,onChangeText:any, options:any, tagType: any) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', marginTop: '24px' }}>
        <div className='advance-filter-container'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px" }}>{title}</span>
            {tagType === "Mail" && <CustomDateField 
                label='From'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.fromMailServerTime || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'fromMailServerTime', value:value}})}
            />}
             {tagType === "Mail" && <CustomDateField 
                label='To'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.toMailServerTime || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'toMailServerTime', value:value}})}
            />}
            {tagType === "Email" && <CustomDateField 
                label='From'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.fromEmailServerTime || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'fromEmailServerTime', value:value}})}
            />}
            {tagType === "Email" && <CustomDateField 
                label='To'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.toEmailServerTime || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'toEmailServerTime', value:value}})}
            />}
        </div>
    </div>
)

const PlatformUpdateDateFilterComp = (title: string,onChangeText:any, options:any) => (
    <div key={title} style={{ width: 'calc(100% - 48px)', marginTop: '24px' }}>
        <div className='advance-filter-container'>
            <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px" }}>{title}</span>
            <CustomDateField 
                label='From'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.fromPlatformTime || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'fromPlatformTime', value:value}})}
            />
            <CustomDateField 
                label='To'
                error={false}
                variant="filled"
                style={{width: '184px'}}
                value={dayjs(options.toPlatformTime || '')}
                handleChange={(value: any)=>onChangeText({date:{key:'toPlatformTime', value:value}})}
            />
        </div>
    </div>
)

const PropertyAddedBy = (title:string,onChangeText:any, options:any) => {

    return(
        <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: '1px solid  #F7F7F7', marginTop: '24px' }}>
            <div style={{justifyContent: 'flex-start'}} className='advance-filter-container'>
                <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
                <FormControl style={{fontSize:"14px", marginLeft: '40px'}}>
                    <RadioGroup
                        name="addedBy"
                        value={options.addedBy}
                        onChange={onChangeText}
                    >
                        <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="internal" control={<Radio color="primary"/>} label="Internal" />
                        <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="external" control={<Radio color="primary"/>} label="External" />
                    </RadioGroup>
                </FormControl>
            </div>
        </div>
    )
}

const HoaType = (title:string,onChangeText:any, options:any) => {
    return(
        <div key={title} style={{ width: 'calc(100% - 48px)', borderBottom: '1px solid  #F7F7F7', marginTop: '24px' }}>
            <div style={{justifyContent: 'flex-start'}} className='advance-filter-container'>
                <span className="filter-field-title-comp" style={{ margin: '2px', width: "85px", wordBreak: 'break-all' }}>{title}</span>
                <FormControl style={{fontSize:"14px", marginLeft: '40px'}}>
                    <RadioGroup
                        name="type"
                        value={options.type}
                        onChange={onChangeText}
                    >
                        <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="masterHoa" control={<Radio color="primary"/>} label="Master HOA" />
                        <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="subHoa" control={<Radio color="primary"/>} label="Sub HOA" />
                    </RadioGroup>
                </FormControl>
            </div>
        </div>
    )
}